import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M57.6 26.9 45.3 14.6C24.7 30.2 11.1 54.8 10 82.5h17.2c1.1-22.8 12.9-42.9 30.4-55.6zm42.6 159.9c1.1 0 2.2-.2 3.3-.4 5.6-1.1 10-5.1 12.3-10.3.9-2.2 1.3-4.5 1.6-6.7H83c0 9.5 7.8 17.4 17.2 17.4zm55.9-100.1c0-26.6-18.3-48.9-43.1-54.7v-5.8c0-7.1-5.8-13-13-13s-13 5.8-13 13v6C62.3 38 43.9 60.4 43.9 86.9v47.6l-17.2 17.4v8.7h146.5v-8.9L156 134.3V86.7zm16.7-4.2v.2H190c-1.3-27.9-15-52.3-35.5-68.1l-12.3 12.3c17.7 12.5 29.3 32.6 30.6 55.6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}